import $ from 'jquery';

$(document).ready(() => {
	$('.navbar-toggler').on('click', (event) => {
		event.preventDefault();
		const $btn = $(event.currentTarget);
		$btn.toggleClass('is-active');
		$($btn.data('nav-target')).toggleClass('show');
	});
	$('.nav-item.has-children > .nav-link').on('click', (event) => {
		// Below the xl breakpoint the toggler is shown and sub menus open on click instead of hover
		if (!$('.navbar-toggler').is(':visible')) {
			return;
		}
		event.preventDefault();
		const $link = $(event.currentTarget);
		const $item = $link.parent().toggleClass('open');
		$link.attr('aria-expanded', $item.hasClass('open'));
	});
	$(window).bind('scroll', (event) => {
		const $header = $('header.header');
		$header.toggleClass('in', $(window).scrollTop() > 300);
	});
});
